import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { InternationalizationHelper } from '../helpers/InternationalizationHelper';

@Component({
  selector: 'app-facebook-login-button',
  templateUrl: './facebook-login-button.component.html',
  styleUrls: ['./facebook-login-button.component.scss']
})
export class FacebookLoginButtonComponent extends BaseComponent implements OnInit {

  @Output() onClick = new EventEmitter();
  lang: string = "en";

  constructor() {
    super();
  }

  ngOnInit() {
    let l = InternationalizationHelper.getTwoCharactersLanguage();
    if(l != "de") { l = "en"; }
    this.lang = l;
  }

  FBLogin() {
    this.onClick.emit();
  }

}
